module.exports = __webpack_public_path__ + "static/media/opionato_logo.d79e1a09.png";